module.exports = __webpack_public_path__ + "static/img/81-2.d12828c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/81-2.jpg
// module id = TKpp
// module chunks = 0